import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./redux/store/store";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.css";
import "./tailwind.css";
import { DataProvider } from "./context/DataContext";
import { HelmetProvider } from "react-helmet-async";
import MetaHelmet from "./component/Meta/MetaHelmet";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <React.Fragment>
      <BrowserRouter>
        <DataProvider>
          <HelmetProvider>
            <MetaHelmet />
            <App />
          </HelmetProvider>
        </DataProvider>
      </BrowserRouter>
    </React.Fragment>
  </Provider>
);

reportWebVitals();
